import { LocTrackingService, LocDataService } from './location-tracking.service';
import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';

/**
 * User this service to create customize http header
 * author: rumesh
 */
@Injectable()
export class CustomizeHttpheaderService {

  constructor(private locTrackingService: LocTrackingService) {
  }

  /**
   * This method will add coordinates to the request header
   */
  addLongAndLat() {
    if (this.locTrackingService.getLongitude()
     && this.locTrackingService.getLatitude()) {
      return {'headers' : new HttpHeaders().set('x-coordinates',
        this.locTrackingService.getLongitude() + ',' + this.locTrackingService.getLatitude())
      };
     }
  }
  addLatLongAndIdempotency() {
    let headers: HttpHeaders = new HttpHeaders();    
    if (this.locTrackingService.getLongitude()
     && this.locTrackingService.getLatitude()) {
      headers = headers.set('x-coordinates', this.locTrackingService.getLongitude() + ',' + this.locTrackingService.getLatitude());      
     }
     if(sessionStorage.getItem('idempotency_key')) {
      headers = headers.append('idempotency-key', sessionStorage.getItem('idempotency_key'));
     }
     return {'headers': headers};
  }
}
